import { Tag } from "@/schema"
import InputLabel from "@ui/badge-input/input-label"
import { Button } from "@ui/shad"
import { cn } from "@ui/utils"

import { TaskLabelSelector } from "@/components/tasks/shared/task-label-selector"

type TaskCreateLabelSelectorProps = {
  label: Tag | null
  onLabelChange: (label: Tag | null) => void
  className?: string
}

export default function TaskCreateLabelSelector({ label, onLabelChange, className }: TaskCreateLabelSelectorProps) {
  const triggerButton = (
    <Button
      variant="outline"
      size="lg"
      type="button"
      className={cn(
        "default flex h-fit w-fit max-w-48 items-center justify-end gap-4 px-2",
        !label && "border-dashed",
        className
      )}
    >
      {label ? (
        <InputLabel
          label={
            <div className="flex w-fit max-w-24 items-center gap-1 truncate">
              <div
                className="size-2 flex-none rounded-full"
                style={{ backgroundColor: label.color || "var(--color-secondary)" }}
              />
              <span className="truncate">{label.name}</span>
            </div>
          }
          description="Label"
          className="text-foreground flex justify-end"
        />
      ) : (
        <InputLabel label="-" description="Label" className="text-muted-foreground" />
      )}
    </Button>
  )

  return <TaskLabelSelector label={label} onLabelChange={onLabelChange} triggerButton={triggerButton} />
}
